import { useQuery } from '@apollo/client';
import { flatMap, last } from 'lodash';
import dynamic from 'next/dynamic';
import React, { useMemo } from 'react';
import Container from '~/components/Container';
import ListContainer from '~/components/ListContainer';
import { ProductListKey, SectionsKey } from '~/constants/enum';
import { RECENTLY_PRODUCT } from '~/constants/localstore';
import { QUERY_OPTIMISTIC_BESTSELLERS } from '~/data/home';
import { renderSectionNew } from '~/utils/pageTwo';
import { transformProductItems } from '~/utils/transform';

type Props = {
    sku?: string;
    directUrl?: string;
    directLabel?: string;
    rootClassName?: string;
    className?: string;
    rootStyles?: React.CSSProperties;
    styles?: React.CSSProperties;
};
const ProductRelated: any = dynamic(() => import('~/components/ProductRelated'), { ssr: false });

const SimilarProduct = ({ sku, directUrl, directLabel, rootClassName, className, rootStyles }: Props) => {
    let recentViewedProducts = [];
    try {
        recentViewedProducts = JSON.parse(localStorage.getItem(RECENTLY_PRODUCT) || '[]');
    } catch (error) { }
    const lastSKU = last(recentViewedProducts);
    const _sku = sku || lastSKU || '';

    const { data: dataBestSeller, loading: loadingBestSeller } = useQuery(QUERY_OPTIMISTIC_BESTSELLERS, {
        variables: { pageSize: 24 },
        context: { fetchOptions: { method: 'GET' } },
        notifyOnNetworkStatusChange: true,
        onError: ({ message }) => console.error(message, 'QUERY_OPTIMISTIC_BESTSELLERS'),
        skip: !!_sku
    });

    // const { data: dataTrending, loading: loadingTrending } = useQuery(
    //   QUERY_OPTIMISTIC_TRENDING,
    //   {
    //     variables: { pageSize: 12 },
    //     context: { fetchOptions: { method: "GET" } },
    //     notifyOnNetworkStatusChange: true,
    //     onError: ({ message }) =>
    //       console.error(message, "QUERY_OPTIMISTIC_BESTSELLERS"),
    //     skip: !!_sku,
    //   }
    // );

    const productsCompiles = useMemo(() => {
        if (!!_sku) return [];
        if (
            !dataBestSeller?.bestSellerProducts?.items?.length
            // !dataTrending?.trendingProducts?.items?.length
        )
            return [];

        return flatMap([
            ...(dataBestSeller?.bestSellerProducts?.items || [])
            // ...(dataTrending?.trendingProducts?.items || []),
        ]);
    }, [dataBestSeller, _sku]);

    return (
        <Container rootStyle={rootStyles} rootClassName={rootClassName} className={className}>
            {!!_sku && <ProductRelated sku={_sku} />}
            {!_sku && (
                <ListContainer
                    title={'More from this shop'}
                    listKey={ProductListKey.Similar}
                    showListLayout={false}
                    defaultLayout={'grid-5'}
                    loading={loadingBestSeller}
                    products={transformProductItems(productsCompiles)}
                    pageSize={24}
                />
            )}
        </Container>
    );
};

export default SimilarProduct;
